import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";

interface ExpanderToggleProps {
    expanded: boolean;
    onClick: () => void;
}

export const ExpanderToggle: FC<ExpanderToggleProps> = (props) => {
    return (
        <div onClick={props.onClick}>
            {props.expanded
                ? (
                    <div>
                        <FontAwesomeIcon icon={faChevronDown} />
                    </div>
                )
                : (
                    <div>
                        <FontAwesomeIcon icon={faChevronRight} />
                    </div>
                )
            }
        </div>
    );
};